export const WhySection = () => (
  <section id="miert" data-testid="why-section" className="bg-mist text-navy py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
      <div className="min-w-0">
        <p className="disp text-burgundy uppercase" style={{ fontSize: "clamp(64px,9vw,120px)", lineHeight: 0.9 }}>
          Minden nap
        </p>
        <h2 data-testid="why-differentiator" className="disp uppercase mt-6" style={{ fontSize: "clamp(32px,4vw,48px)", lineHeight: 1.1 }}>
          Közel lakom, és minden nap meg tudom látogatni.
        </h2>
        <p data-testid="why-differentiator-2" className="text-xl mt-6 max-w-[34rem]">
          Állandó ápolót és étkeztetést is biztosítok.
        </p>
      </div>
      <figure className="relative aspect-[4/5] overflow-hidden bg-mist-deep">
        <img
          src="https://images.unsplash.com/photo-1601617956235-c97e358d054f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000"
          alt="Napfényes, otthonos nappali fotellel"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <figcaption className="absolute left-4 bottom-4 bg-ivory px-3 py-1 text-sm uppercase tracking-[.14em] text-sage-ink font-semibold">
          Az Ön otthona, az Ön rendje
        </figcaption>
      </figure>
    </div>
  </section>
);

export const ReviewsSection = () => (
  <section id="velemenyek" data-testid="reviews-section" className="bg-ivory text-navy py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[240px_1fr] gap-12 items-center">
      <h2 className="disp uppercase min-w-0" style={{ fontSize: "clamp(32px,4vw,56px)", lineHeight: 1.1 }}>Vélemények</h2>
      <div className="border-2 border-dashed border-navy/40 p-8 md:p-12 flex items-center gap-8">
        <span className="disp text-burgundy" style={{ fontSize: "clamp(64px,9vw,120px)", lineHeight: 1 }} aria-hidden="true">“</span>
        <p data-testid="reviews-placeholder" className="text-xl">Az első családok visszajelzései hamarosan itt olvashatók.</p>
      </div>
    </div>
  </section>
);
